















import { Vue, Component } from "vue-property-decorator";
import CategoryForm from "@/components/category/CategoryForm.vue";
import { isRoot } from "@/plugins/roles";

@Component({
  components: { CategoryForm }
})
export default class CategoryNew extends Vue {
  get root() {
    return isRoot();
  }
}
